import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { Button } from '@/components/atoms/Buttons';
import FormField from '@/components/atoms/FormField';
import Select from '@/components/atoms/Select';
import ModalComponent from '@/components/molecules/ModalComponent/ModalComponent';

export interface AddProviderModalProps {
    isOpen: boolean;
    /** Providers with a schema that the site has no rows for yet. */
    providerNames: string[];
    onAdd: (providerName: string) => void;
    onClose: () => void;
}

function AddProviderModal({ isOpen, providerNames, onAdd, onClose }: AddProviderModalProps) {
    const { t } = useTranslation();
    const [chosen, setChosen] = useState('');
    const value = providerNames.includes(chosen) ? chosen : (providerNames[0] ?? '');

    return (
        <ModalComponent
            isOpen={isOpen}
            onClose={onClose}
            title={t('providerConfig.add.title')}
            body={
                <FormField label={t('providerConfig.add.choose')}>
                    <Select value={value} onChange={(event) => setChosen(event.target.value)}>
                        {providerNames.map((name) => (
                            <option key={name} value={name}>
                                {t(`providerConfig.providers.${name}`)}
                            </option>
                        ))}
                    </Select>
                </FormField>
            }
            footer={
                <>
                    <Button variant="secondary" onClick={onClose}>
                        {t('providerConfig.add.cancel')}
                    </Button>
                    <Button variant="primary" disabled={value === ''} onClick={() => onAdd(value)}>
                        {t('providerConfig.add.add')}
                    </Button>
                </>
            }
        />
    );
}

export default AddProviderModal;
export { AddProviderModal };
